import React, { useEffect, useState } from 'react';
import styles from './BrokerHealthStatusGadget.module.scss';
import { useSelector } from 'react-redux';
import { getHealthStatusOrderApis } from '../../store/getters/health-status';
import BrokerExpand from './BrokerExpand/BrokerExpand';
import BrokerNumber from './BrokerNumber/BrokerNumber';
import BrokerOverlay from './BrokerOverlay';
import HealthStatusWithText from '../HealthStatus/HealthStatusWithText';
import { isMobile } from '../../hooks/user-device';

export function useGetBrokersListStats() {
  const healthStatusOrderApis = useSelector(getHealthStatusOrderApis) || [];

  const brokersGreen = healthStatusOrderApis.filter(
    (item) => item.status === 'GREEN'
  );
  const brokersRed = healthStatusOrderApis.filter(
    (item) => item.status === 'RED'
  );
  const brokersOrange = healthStatusOrderApis.filter(
    (item) => item.status === 'ORANGE'
  );
  const brokersGrey = healthStatusOrderApis.filter(
    (item) => item.status === 'GREY'
  );

  return {
    brokersGreen,
    brokersRed,
    brokersOrange,
    brokersGrey,
  };
}

function useTotalTextLength(brokers, windowWidthRaw) {
  let splitAfter = 0;
  let adder = 0;

  const windowWidth = windowWidthRaw - 200;

  for (let index = 0; index < brokers.length; index++) {
    const element = brokers[index];
    const length = isMobile
      ? element.id.length * 1.8 + 90
      : element.id.length * 1.6 + 58;

    adder += length;

    if (adder > windowWidth) {
      splitAfter = index;
      break;
    }
  }

  return splitAfter;
}

function CreateGadget({
  brokers,
  color,
  isOpenByDefault = false,
  onClick,
  children,
}) {
  const brokersTotal = brokers.length;

  return (
    <>
      {brokers.length ? (
        <BrokerExpand
          value={color}
          total={brokersTotal}
          buttonContent={
            color !== 'RED' ? (
              <BrokerNumber value={brokersTotal} color={color} />
            ) : (
              ''
            )
          }
          isOpenByDefault={isOpenByDefault}
          onClick={onClick}
        >
          {children}
        </BrokerExpand>
      ) : (
        ''
      )}
    </>
  );
}

const BrokerHealthStatusGadget = () => {
  const { brokersGreen, brokersRed, brokersOrange, brokersGrey } =
    useGetBrokersListStats();
  const [openOverlay, setOpenOverlay] = useState(false);

  const [width, setWidth] = useState(window.innerWidth);
  const totalTextLength = useTotalTextLength(brokersRed, width);
  const brokersRedAdjusted = totalTextLength
    ? brokersRed.slice(0, totalTextLength)
    : brokersRed;

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    // Cleanup on unmount or when color changes
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function onClick() {
    setOpenOverlay(true);
  }

  return (
    <div
      className={`${styles.BrokerHealthStatusGadget} BrokerHealthStatusGadget`}
    >
      <CreateGadget brokers={brokersRedAdjusted} color="RED" onClick={onClick}>
        <>
          {brokersRedAdjusted.map(({ status = '', id = '' }) => (
            <HealthStatusWithText
              status={status}
              baseLabel={id}
              key={id}
              onClick={onClick}
            />
          ))}
          {totalTextLength ? (
            <HealthStatusWithText
              status="RED"
              baseLabel=" ... "
              key="blank-123456"
              onClick={onClick}
            />
          ) : (
            ''
          )}
        </>
      </CreateGadget>
      <CreateGadget brokers={brokersOrange} color="ORANGE" onClick={onClick} />
      <CreateGadget brokers={brokersGrey} color="GREY" onClick={onClick} />
      <CreateGadget brokers={brokersGreen} color="GREEN" onClick={onClick} />
      <BrokerOverlay
        open={openOverlay}
        onDismiss={() => setOpenOverlay(false)}
      />
    </div>
  );
};

export default BrokerHealthStatusGadget;
